<template>
  <div class="more-away">
    <div class="ha-des">
      <p class="black">问：我点击做作业，提示我“课程未购买”</p>
      <p>答：请您确认要做作业的课程您已经购买过，请您确认您登陆的账号与已经激活课程的账号一致。如果您要做作业的课程已经购买过了，那么请您尝试更换家里其他人的手机号进行登录，因为您家里人可能将课程激活在其他账号（手机号）上了。</p>
    </div>
    
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .more-away {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {}
    },
    created(){
      document.title = '其他问题? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击我点击做作业，提示我“课程未购买”')
    },
    methods: {
      skip(name) {
        this.$router.push({
          name: name
        });
      }
    },
    components: {}
  }
</script>
